// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__22VUQ","inner":"Footer_inner__1QNRD","nextIcon":"Footer_nextIcon__1k2Qm","innerLeft":"Footer_innerLeft__2UlWf"};